<template>
  <div :class="['mt2', 'inline-edit', { highlight: showHighlight() }]">
    <i
      v-if="canEdit && !edit"
      class="fa fa-pencil has-text-light pull-right pointer"
      @click="toggleEdit"
    ></i>
    <i
      v-if="edit && !loading"
      class="fa fa-times pull-right pointer has-text-light"
      @click="toggleEdit"
    ></i>
    <i
      v-if="edit && !loading"
      class="fa fa-floppy-o pull-right pointer has-text-primary"
      @click="onSave"
    ></i>
    <i v-if="edit && loading" class="fa fa-refresh fa-spin pull-right"></i>

    <h3>Review of Systems</h3>

    <div v-if="!edit" class="value">
      <ul>
        <li v-for="r in value">
          {{ r.name }} - {{ r.duration }}
          <span v-if="r.notes">- {{ r.notes }}</span>
        </li>
      </ul>
    </div>
    <div v-if="edit" class="inline-edit">
      <reason-selector :rfv="value" @updated="reasonUpdated"></reason-selector>
    </div>
  </div>
</template>

<script>
import ReasonSelector from "./ReasonSelector";

export default {
  name: "inline-edit-reason",

  props: ["value", "onSubmit", "canEdit", "highlightField"],

  components: {
    ReasonSelector
  },

  data() {
    return {
      field: "reviewOfSystems",
      edit: false,
      editValue: this.value,
      loading: false,
      highlight: false
    };
  },

  computed: {
    isUser() {
      return this.$store.getters.isUser;
    }
  },

  methods: {
    toggleEdit() {
      this.edit = !this.edit;
      if (!this.edit) {
        this.editValue = this.value;
      }
    },
    onSave() {
      this.loading = true;
      this.onSubmit(this.field, this.editValue).then(() => {
        this.loading = false;
        this.edit = false;
      });
    },
    showHighlight() {
      return this.field === this.highlightField;
    },
    reasonUpdated(reasons) {
      this.editValue = reasons;
    }
  }
};
</script>

<style lang="scss" scoped>
.inline-edit {
  .fa {
    font-size: 98%;
    margin-right: 0.5rem;
  }
  &.highlight {
    background: #53f4ff;
    border-radius: 5px;
  }
}
</style>
